import { __extends } from "tslib";
import { TextFormat as AwaytextFormat } from '@awayjs/scene';
import { ASObject } from '@awayfl/avm2';
import { Debug } from '@awayjs/core';
var TextFormat = /** @class */ (function (_super) {
    __extends(TextFormat, _super);
    function TextFormat(font, size, color, bold, italic, underline, url, link_target, align, leftMargin, rightMargin, indent, leading) {
        if (font === void 0) { font = null; }
        if (size === void 0) { size = null; }
        if (color === void 0) { color = null; }
        if (bold === void 0) { bold = null; }
        if (italic === void 0) { italic = null; }
        if (underline === void 0) { underline = null; }
        if (url === void 0) { url = null; }
        if (link_target === void 0) { link_target = null; }
        if (align === void 0) { align = null; }
        if (leftMargin === void 0) { leftMargin = null; }
        if (rightMargin === void 0) { rightMargin = null; }
        if (indent === void 0) { indent = null; }
        if (leading === void 0) { leading = null; }
        var _this = _super.call(this) || this;
        _this.adaptee = new AwaytextFormat(font, size, color, bold, italic, underline, url, link_target, align, leftMargin, rightMargin, indent, leading);
        return _this;
    }
    Object.defineProperty(TextFormat.prototype, "target", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/TextFormat', 'get target', '');
            return null;
        },
        set: function (value) {
            // @todo
            Debug.throwPIR('playerglobals/text/TextFormat', 'set target', '');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "tabStops", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/TextFormat', 'get tabStops', '');
            return null;
        },
        set: function (value) {
            // @todo
            Debug.throwPIR('playerglobals/text/TextFormat', 'set tabStops', '');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "display", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/TextFormat', 'get display', '');
            return null;
        },
        set: function (value) {
            // @todo
            Debug.throwPIR('playerglobals/text/TextFormat', 'set display', '');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "bullet", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/TextFormat', 'get bullet', '');
            return null;
        },
        set: function (value) {
            // @todo
            Debug.throwPIR('playerglobals/text/TextFormat', 'set bullet', '');
            //this._bullet = TextFormat.coerceBoolean(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "url", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/TextFormat', 'get url', '');
            return null;
        },
        set: function (value) {
            // @todo
            Debug.throwPIR('playerglobals/text/TextFormat', 'set url', '');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "link_target", {
        /**
         * Indicates the target window where the hyperlink is displayed. If the
         * target window is an empty string, the text is displayed in the default
         * target window <code>_self</code>. You can choose a custom name or one of
         * the following four names: <code>_self</code> specifies the current frame
         * in the current window, <code>_blank</code> specifies a new window,
         * <code>_parent</code> specifies the parent of the current frame, and
         * <code>_top</code> specifies the top-level frame in the current window. If
         * the <code>TextFormat.url</code> property is an empty string or
         * <code>null</code>, you can get or set this property, but the property will
         * have no effect.
         */
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/TextFormat', 'get target', '');
            return null;
        },
        set: function (value) {
            // @todo
            Debug.throwPIR('playerglobals/text/TextFormat', 'get target', '');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "align", {
        get: function () {
            return this.adaptee.align;
        },
        set: function (value) {
            this.adaptee.align = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "blockIndent", {
        get: function () {
            return this.adaptee.blockIndent;
        },
        set: function (value) {
            this.adaptee.blockIndent = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "leftMargin", {
        get: function () {
            return this.adaptee.leftMargin;
        },
        set: function (value) {
            this.adaptee.leftMargin = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "rightMargin", {
        get: function () {
            return this.adaptee.rightMargin;
        },
        set: function (value) {
            this.adaptee.rightMargin = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "indent", {
        get: function () {
            return this.adaptee.indent;
        },
        set: function (value) {
            this.adaptee.indent = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "color", {
        get: function () {
            return this.adaptee.color;
        },
        set: function (value) {
            this.adaptee.color = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "kerning", {
        get: function () {
            return this.adaptee.kerning;
        },
        set: function (value) {
            this.adaptee.kerning = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "leading", {
        get: function () {
            return this.adaptee.leading;
        },
        set: function (value) {
            this.adaptee.leading = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "letterSpacing", {
        get: function () {
            return this.adaptee.letterSpacing;
        },
        set: function (value) {
            this.adaptee.letterSpacing = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "size", {
        get: function () {
            return this.adaptee.size;
        },
        set: function (value) {
            this.adaptee.size = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "bold", {
        get: function () {
            return this.adaptee.bold;
        },
        set: function (value) {
            this.adaptee.bold = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "italic", {
        get: function () {
            return this.adaptee.italic;
        },
        set: function (value) {
            this.adaptee.italic = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "underline", {
        get: function () {
            return this.adaptee.underline;
        },
        set: function (value) {
            this.adaptee.underline = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "font", {
        get: function () {
            // in awayjs textformat, font is a Awayjs Font object
            // we have font_name for the font name string
            return this.adaptee.font_name;
        },
        set: function (value) {
            this.adaptee.font = value;
        },
        enumerable: true,
        configurable: true
    });
    TextFormat.prototype.clone = function () {
        //console.log("not implemented: textFOrmat.clone");
        var clonedFormat = new this.sec.flash.text.TextFormat();
        clonedFormat.adaptee = this.adaptee.clone();
        return clonedFormat;
    };
    return TextFormat;
}(ASObject));
export { TextFormat };
